import React, { useEffect } from 'react';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
    FUNNEL_ADDRESS_STEP,
    FUNNEL_FRAUD_VERIFICATION_STEP,
    FUNNEL_PAYMENT_SELECTION_STEP,
    FUNNEL_PAYMENT_PROCESSING_STEP
} from '../../constants/funnel';

import { mergeQueryLocked } from '../../utils/ebonUtils';

import FunnelAddressStep from './address-step/FunnelAddressStep';
import FunnelPaymentStep from './payment-step/FunnelPaymentStep';
import FunnelPaymentSelectionStep from './payment-selection-step/FunnelPaymentSelectionStep';
import FunnelFraudVerificationStep from './fraud-verification-step/FunnelFraudVerificationStep';

import { LeftContainer } from './FunnelLeftContainerStyle';

const FunnelLeftContainer = ({
    partnerId,
    partnerName,
    userInfo,
    setUserInfo,
    paymentType,
    setPaymentType,
    cartTotalValue,
    stateOfTransaction,
    setStateOfTransaction,
    setModalData,
    merchantCardPath,
    order,
    ebon,
    lock
}) => {
    // Handle lock response
    useEffect(() => {
        if (!isEmpty(lock)) {
            const { allLocked } = lock;
            if (!allLocked) {
                delete lock.allLocked;
                const final = mergeQueryLocked(ebon.cart, lock);
                return setModalData(final);
            } else {
                setStateOfTransaction(FUNNEL_FRAUD_VERIFICATION_STEP);
            }
        }
    }, [lock]);

    // Handle order response
    useEffect(() => {
        if (order.orderState === 'created' && lock.allLocked) {
            setStateOfTransaction(FUNNEL_PAYMENT_SELECTION_STEP);
            return;
        }
    }, [order]);

    return (
        <LeftContainer>
            {stateOfTransaction === FUNNEL_ADDRESS_STEP && (
                <FunnelAddressStep
                    partnerId={partnerId}
                    setUserInfo={setUserInfo}
                    merchantCardPath={merchantCardPath}
                />
            )}

            {stateOfTransaction === FUNNEL_FRAUD_VERIFICATION_STEP && (
                <FunnelFraudVerificationStep partnerId={partnerId} userInfo={userInfo} />
            )}

            <div className="leftInnerContainer">
                {stateOfTransaction === FUNNEL_PAYMENT_SELECTION_STEP && (
                    <FunnelPaymentSelectionStep
                        setPaymentType={setPaymentType}
                        cartTotalValue={cartTotalValue}
                    />
                )}

                {stateOfTransaction === FUNNEL_PAYMENT_PROCESSING_STEP && (
                    <FunnelPaymentStep
                        userInfo={userInfo}
                        partnerId={partnerId}
                        partnerName={partnerName}
                        order={order}
                        cartTotalValue={cartTotalValue}
                        paymentType={paymentType}
                    />
                )}
            </div>
        </LeftContainer>
    );
};

const mapStateToProps = state => {
    return {
        order: state.ebon.createdOrder,
        ebon: state.ebon,
        lock: state.ebon.lock
    };
};

FunnelLeftContainer.propTypes = {
    partnerId: PropTypes.number,
    partnerName: PropTypes.string,
    userInfo: PropTypes.object,
    setUserInfo: PropTypes.func,
    paymentType: PropTypes.string,
    setPaymentType: PropTypes.func,
    cartTotalValue: PropTypes.number,
    stateOfTransaction: PropTypes.string,
    setStateOfTransaction: PropTypes.func,
    setModalData: PropTypes.func,
    merchantCardPath: PropTypes.string
};

export default connect(mapStateToProps)(FunnelLeftContainer);



// WEBPACK FOOTER //
// ./src/components/funnel/FunnelLeftContainer.js